<template>
  <div v-if="_validation.$error && _validation.$dirty" aria-live="polite">
    <template v-for="rule in _validation.$params">
      <WCValidationMessage v-if="rule && !_validation[rule.type]" :key="rule.type">
        {{ getValidationMessage(rule) }}
      </WCValidationMessage>
    </template>
  </div>
</template>

<script>
import { getMessage } from '@/utils/validation/validation';
import WCValidationMessage from '../WCValidationMessage/WCValidationMessage.vue';

export default {
  name: 'WCValidationErrors',
  components: { WCValidationMessage },
  inject: {
    field: { default: undefined },
  },
  props: {
    validation: {
      type: Object,
    },
  },
  methods: {
    getValidationMessage(rule) {
      return getMessage({ ...rule });
    },
  },
  computed: {
    _validation() {
      return this.field ? this.field : this.validation;
    },
  },
};
</script>

<style lang="scss" scoped></style>
